// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"63d6c0eb","453":"67634348","701":"ca5f88d7","736":"ba2c1746","861":"b8fbf8d9"}[chunkId] + ".chunk.js";
};